import { useQuery } from "@tanstack/react-query";
import { fetchUserHomePagePets } from "../../../enums/queryFunction/Fetch";
import { PETS_USER_HOMEPAGE } from "../../../enums/QueryKeys";

export default function useGetHomePageUserPets(profileId) {
  const { data, isLoading, error } = useQuery({
    queryKey: [PETS_USER_HOMEPAGE, profileId],
    queryFn: () => fetchUserHomePagePets(profileId),
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    enabled: !!profileId,
  });

  return { data, isLoading, error };
}
